<div class="day-information">
    @if (dayInformation) {

        <div>

            <div class="flex flex-col gap-4">

                <!-- Phase - Day Picker - Sign -->
                <div class="day-header-layout">

                    <!-- Moon -->
                    <div class="moon-slot">
                        <mat-card (click)="openMoonDetails()" class="moon-details hero-tile">
                            <mat-card-content>
                                <div class="flex flex-col items-center">
                                    <img
                                            alt="{{'PHASE.' + dayInformation.phase | translate}}"
                                            class="day-img"
                                            src="assets/images/moon/moon_{{dayInformation.phase}}.webp"
                                    >

                                    <p>
                                        {{ 'PHASE.' + dayInformation.phase | translate }}
                                    </p>

                                    @if (dayInformation.moonPeak) {
                                        <div>
                                            <p>
                                                {{ 'DAY.AT' | translate }}
                                                {{ dayInformation.moonPeak | timeShort }}
                                                {{ 'DAY.CLOCK' | translate }}
                                            </p>
                                        </div>
                                    }
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>


                    <!-- Date + Day Picker -->
                    <div class="date-slot flex flex-col items-center">
                        <h1 class="today-title" [class.today-title-hidden]="!relativeDay">
                            {{ 'MENU.MAIN' | translate }}
                            <span class="day-badge day-badge-past" [class.day-badge-hidden]="relativeDay !== 'yesterday'">
                                {{ 'DAY_INFORMATION.YESTERDAY_BADGE' | translate }}
                            </span>
                            <span class="day-badge" [class.day-badge-hidden]="relativeDay !== 'today'">
                                {{ 'DAY_INFORMATION.TODAY_BADGE' | translate }}
                            </span>
                            <span class="day-badge" [class.day-badge-hidden]="relativeDay !== 'tomorrow'">
                                {{ 'DAY_INFORMATION.TOMORROW_BADGE' | translate }}
                            </span>
                        </h1>

                        <h2 class="date-title">
                            {{ dayInformation.day | dateShort }}
                        </h2>

                        <div class="flex flex-row items-center gap-2">
                            <a [routerLink]="language.route('/day/' + getSwitchDate(-1))">
                                <img
                                        alt="{{'ALT.DAY_BACK' | translate}}"
                                        class="direction-arrow"
                                        src="assets/images/month/left.svg"
                                >
                            </a>

                            <div class="day-picker">
                                <mat-form-field appearance="outline">
                                    <mat-label>
                                        {{ 'DAY_INFORMATION.CHOOSE_DATE' | translate }}
                                    </mat-label>

                                    <input
                                            (dateChange)="switchDay($event)"
                                            [(ngModel)]="dayInformation.day"
                                            [matDatepicker]="picker"
                                            matInput
                                    >

                                    <mat-datepicker-toggle
                                            [for]="picker"
                                            matSuffix>
                                    </mat-datepicker-toggle>

                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <a [routerLink]="language.route('/day/' + getSwitchDate(1))">
                                <img
                                        alt="{{'ALT.DAY_NEXT' | translate}}"
                                        class="direction-arrow"
                                        src="assets/images/month/right.svg"
                                >
                            </a>
                        </div>
                    </div>


                    <!-- Sign -->
                    <div class="sign-slot">
                        <mat-card (click)="openSignDetails()" class="moon-details hero-tile">
                            <mat-card-content>
                                <div class="flex flex-col items-center">
                                    <img
                                            alt="{{'SIGN.' + dayInformation.sign.id.toUpperCase() | translate}}"
                                            class="day-img"
                                            src="assets/images/sign/{{dayInformation.sign.id}}.webp"
                                    >

                                    <p>
                                        {{ 'SIGN.' + dayInformation.sign.id.toUpperCase() | translate }}
                                    </p>

                                    @if (dayInformation.signSwitch) {
                                        <div>
                                            <p>
                                                {{ 'DAY.UNTIL' | translate }}
                                                {{ dayInformation.signSwitch | timeShort }}
                                                {{ 'DAY.CLOCK' | translate }}
                                            </p>
                                        </div>
                                    }
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                </div>

                <!-- Additional information row -->
                <div class="attribute-grid">
                    <mat-card (click)="openElementDetails()" class="day-element attribute-card">
                        <mat-card-title>
                            <p class="attribute-header">{{ 'ATTRIBUTE.ELEMENT' | translate }}</p>
                        </mat-card-title>
                        <mat-card-content>
                            <div class="">
                                <img alt="{{'ELEMENT.' + getElement().toUpperCase() | translate}}" class="attribute-img"
                                     src="assets/images/element/{{getElement()}}.webp">
                                <p>{{ 'ELEMENT.' + getElement().toUpperCase() | translate }}</p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <mat-card (click)="openGardenDetails()" class="garden-element attribute-card">
                        <mat-card-title>
                            <p class="attribute-header">{{ 'ATTRIBUTE.GARDEN' | translate }}</p>
                        </mat-card-title>
                        <mat-card-content>
                            <div class="">
                                <img alt="{{'GARDEN.' + getGarden().toUpperCase() | translate}}" class="attribute-img"
                                     src="assets/images/garden/{{getGarden()}}.webp">
                                <p>{{ 'GARDEN.' + getGarden().toUpperCase() | translate }}</p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <mat-card class="body-part-element attribute-card">
                        <mat-card-title>
                            <p class="attribute-header">{{ 'ATTRIBUTE.BODY_PART' | translate }}</p>
                        </mat-card-title>
                        <mat-card-content>
                            <p> {{ 'ATTRIBUTE.BODY_PARTS.' + dayInformation.sign.id.toUpperCase() | translate }}</p>
                        </mat-card-content>
                    </mat-card>
                    <mat-card class="organ-system-element attribute-card">
                        <mat-card-title>
                            <p class="attribute-header">{{ 'ATTRIBUTE.ORGAN_SYSTEM' | translate }}</p>
                        </mat-card-title>
                        <mat-card-content>
                            <p>{{ 'ATTRIBUTE.ORGAN_SYSTEMS.' + getOrganSystem().toUpperCase() | translate }}</p>
                        </mat-card-content>
                    </mat-card>
                    <mat-card class="direction-element attribute-card">
                        <mat-card-title>
                            <p class="attribute-header">{{ 'ATTRIBUTE.DIRECTION' | translate }}</p>
                        </mat-card-title>
                        <mat-card-content>
                            <p>{{ 'ATTRIBUTE.DIRECTIONS.' + getDirection().toUpperCase() | translate }}</p>
                        </mat-card-content>
                    </mat-card>
                    <mat-card (click)="openNutritionDetails()"
                              class="nutrition-element attribute-card">
                        <mat-card-title>
                            <p class="attribute-header">{{ 'ATTRIBUTE.NUTRITION_QUALITY' | translate }}</p>
                        </mat-card-title>
                        <mat-card-content>
                            <div class="">
                                <img alt="{{'NUTRITION.' + getNutritionQuality().toUpperCase() | translate}}"
                                      class="attribute-img" src="assets/images/nutrition/{{getNutritionQuality()}}.webp">
                                <p>{{ 'NUTRITION.' + getNutritionQuality().toUpperCase() | translate }}</p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <mat-card (click)="openDayQualityDetails()"
                              class="day-quality-element attribute-card">
                        <mat-card-title>
                            <p class="attribute-header">{{ 'ATTRIBUTE.DAY_QUALITY' | translate }}</p>
                        </mat-card-title>
                        <mat-card-content>
                            <div class="">
                                <img alt="{{'DAY_QUALITY.' + getDayQuality().toUpperCase() | translate}}"
                                     class="attribute-img" src="assets/images/day_quality/{{getDayQuality()}}.webp">
                                <p>{{ 'DAY_QUALITY.' + getDayQuality().toUpperCase() | translate }}</p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>

        </div>
    }
</div>
